module.exports = __webpack_public_path__ + "static/media/huoshaoshan_package.a10cd853.webp";